const themeLarge = {
  colors: {
    primary: "#244F26", // #E71D36
    secondary: "#FFFAE3",
    hover: "#FF0000",
    text: "#251605", // #541388
    bg: "#FFF4F9",
    gradient: "#FFC85C",
  },
  fontSize: {
    display: "60px",
    h1: "40px",
    h2: "32px",
    h3: "24px",
    h4: "20px",
    body: "18px",
    small: "14px",
  },
  shadows: {
    standard: "0px 4px 6px rgba(0, 0, 0, 0.25)",
    large: "0px 8px 6px rgba(0, 0, 0, 0.25)",
    little: "0px 2px 2px rgba(0, 0, 0, 0.25)",
    littleReverse: "0px -2px 2px rgba(0, 0, 0, 0.25)",
    textShadow: "0px 5px 7px rgba(0, 0, 0, 0.25)",
    nothing: "0px 0px 0px rgba(0, 0, 0, 0)",
  },
};

export default themeLarge;
